export function toggleSelectValue({
  current,
  value,
  allowMultiple = true,
  max = Infinity,
  exclusiveValue,
}) {
  if (value === exclusiveValue) {
    return [exclusiveValue];
  }

  let next = current.filter((v) => v !== exclusiveValue);

  if (!allowMultiple) {
    return [value];
  }

  if (next.includes(value)) {
    next = next.filter((v) => v !== value);
  } else {
    if (next.length >= max) return next;
    next.push(value);
  }

  return next;
}
